/**
 * Basic go top functionality
 */

let isSmoothScrollingSupported;

function init() {
  isSmoothScrollingSupported = CSS.supports("scroll-behavior", "smooth");
  const goTopElements = document.querySelectorAll(".js-gotop");

  goTopElements.forEach((el) => {
    el.addEventListener("click", scrollToTop);
  });
}

function scrollToTop() {
  /**
   * scrollTo({ … behavior: "smooth" }) is supported on Mac OS/iOS since April 2021.
   * If not supported, scrollTo() will scroll the page _directly_ to the specified position.
   * To solve this issue we test support for CSS 'scroll-behavior: smooth',
   * which is equally well supported as scrollTo({ … behavior: "smooth" })
   */
  isSmoothScrollingSupported
    ? document.documentElement.scrollTo({ top: 0, behavior: "smooth" })
    : $("html,body").animate({ scrollTop: 0 }, 600);
}

export { init };
